<template>
  <div class="audioParam">
    <el-row>
      <el-col
        :span="12"
        :push="6"
      >
        <div
          class="grid-content "
          v-if="bolcode.parentOrgnCode === '0'"
        >
          机构代码:&emsp;<el-input v-model="originData.orgnCodeLv3">
          </el-input>
        </div>
      </el-col>
    </el-row>

    <p v-if="bolcode.parentOrgnCode === '0'">
      <br />
      <button
        class="btn btn--search"
        @click='query'
      >查询</button>
      <button
        class="btn btn--reset"
        @click='reset'
      >重置</button>
    </p>
    <p
      style="margin-left: -96%"
      v-if="bolcode.parentOrgnCode === '0'"
    >
      <button
        class="btn_disable"
        @click.stop="showAddOrUpdate('update')"
      >修改</button>
      <br>
    </p>

    <yh-dialog
      :title="'音频参数修改'"
      :visible.sync="audioaddDialog"
    >
      <el-form
        :model="audioParam"
        ref="audioParam"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="机构FTP IP地址："
              prop="serverIp"
            >
              <el-input
                v-model="audioParam.serverIp"
                style="width: 100%;"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="机构FTP端口："
              prop="uploadPort"
            >
              <el-input
                v-model="audioParam.uploadPort"
                style="width: 100%;"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="机构FTP路径："
              prop="uploadPath"
            >
              <el-input
                v-model="audioParam.uploadPath"
                style="width: 100%;"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="状态"
              prop="status"
            >
              <el-select
                style="width: 100%;"
                v-model="audioParam.status"
                placeholder="请选择"
              >
                <el-option
                  v-for="(item,index) in audioParamStatusDict"
                  :label="item.dictName"
                  :value="item.dictValue"
                  :key="index"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="FTP用户名："
              prop="uploadUser"
            >
              <el-input
                v-model="audioParam.uploadUser"
                style="width: 100%;"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="FTP密码："
              prop="uploadPassword"
            >
              <el-input
                v-model="audioParam.uploadPassword"
                style="width: 100%;"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="上传开始时间："
              prop="uploadStartTime"
            >
              <el-time-picker
                v-model="audioParam.uploadStartTime"
                value-format='HH:mm:ss'
              >
              </el-time-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="上传结束时间："
              prop="uploadEndTime"
            >
              <el-time-picker
                v-model="audioParam.uploadEndTime"
                value-format='HH:mm:ss'
              >
              </el-time-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer">
        <el-button
          class="btn_foot"
          @click="audioaddDialog=false"
        >取 消</el-button>
        <el-button
          class="btn_foot_save"
          type="primary"
          @click="saveAudioParam"
        >确 定</el-button>
      </span>
    </yh-dialog>

    <el-table
      highlight-current-row
      @row-click="showRow"
      :data="tableData"
      tooltip-effect="dark"
    >
      <template slot="empty">
        <div>{{tablemsg}}</div>
      </template>

      <el-table-column
        label=""
        width="70"
      >
        <template slot-scope="scope">
          <el-radio
            :label="scope.row.orgnCode"
            v-model="radio"
          >&nbsp;</el-radio>
        </template>
      </el-table-column>
      <el-table-column
        label='序号'
        width="60"
      >
        <template slot-scope="scope">
          {{scope.$index+1}}
        </template>
      </el-table-column>
      <el-table-column
        v-for="item in thMap"
        :key="item.prop"
        :label="item.label"
        :prop="item.prop"
        :show-overflow-tooltip="item.showTip"
        :width="item.width"
      ></el-table-column>
      <el-table-column
        label='状态'
        :formatter="getStatus"
        prop="status"
      >
      </el-table-column>

    </el-table>
    <div
      class='pagination'
      style="background-color: #fff"
    >
      <span>共{{sumCount}}条信息，当前 {{currentPage}}/{{pageCount}}页</span>
    </div>
    <el-pagination
      :current-page.sync="currentPage"
      :page-size="pageSize"
      layout="prev, pager, next,jumper"
      :total="sumCount"
    >
    </el-pagination>
    <br />
  </div>
</template>

<script>
import {
  clearBy, getFunctionList, pageCount, getPagingData,
} from '@/mixins';

export default {
  name: 'AudioParam',
  mixins: [clearBy, getFunctionList, pageCount, getPagingData],
  data() {
    const sessionData = JSON.parse(sessionStorage.getItem('sessionData'));
    return {
      // table 中的 label 及对应的数据字段
      thMap: [
        {
          label: '机构代码',
          prop: 'orgnCode',
          showTip: true,
        },
        {
          label: '机构名称',
          prop: 'orgnName',
          showTip: true,
          width: 300,
        },
        {
          label: '设备号',
          prop: 'logDeviceId',
          showTip: true,
        },
        {
          label: 'IP地址',
          prop: 'serverIp',
          showTip: true,
        },
        {
          label: 'FTP端口',
          prop: 'uploadPort',
          showTip: true,
        },
        {
          label: '路径',
          prop: 'uploadPath',
          showTip: false,
        },
        {
          label: '用户名',
          prop: 'uploadUser',
          showTip: false,
        },
        {
          label: '上传开始时间',
          prop: 'uploadStartTime',
          showTip: false,
        },
        {
          label: '上传结束时间',
          prop: 'uploadEndTime',
          showTip: false,
        },
      ],
      tablemsg: '暂时数据',
      audioParamStatusDict: [],
      audioaddDialog: false, // 新增或修改弹框
      radio: '',
      pageNo: 1, // 页码
      currentPage: 1, // 当前页
      pageSize: 10, // 每页显示记录数
      sumCount: 0, // 总记录数
      tableData: [],
      choseMenuDialog: false,
      orgncode: '',
      bolcode: '',
      audioParam: {
        id: '',
        orgnCodeLv3: sessionData.orgnCodeLv3,
        serverIp: '',
        uploadPort: '',
        uploadPath: '',
        uploadUser: '',
        uploadPassword: '',
        status: '',
        createUserCode: sessionData.userCode,
        updateUserCode: sessionData.userCode,
        uploadStartTime: '',
        uploadEndTime: '',
      },
      // 是否显示新增按钮
      showsave: true,
      audioCode: '',
      originData: { orgnCodeLv3: '' },
      searchParam: { orgnCodeLv3: '' },
      audioCodeName: '',
      defaultProps: {
        children: 'children',
        label: 'title',
      },
      radioRow: '',
      functionList: [],
      checkedObj: {
        orgnCodeLv3: '',
      },
    };
  },
  watch: {
    currentPage: {
      immediate: true,
      handler() {
        this.getTableData();
      },
    },
  },
  mounted() {
    this.queryAudioParamStatusDict();
    this.bolcode = JSON.parse(sessionStorage.getItem('sessionData'));
    if (!this.bolcode.orgnCodeLv3) {
      this.audioCode = this.bolcode.orgnCodeLv3;
    }
  },
  methods: {
    // 列表状态展示处理
    getStatus(key) {
      const statusMap = {
        0: '禁用',
        1: '启用',
      };
      return statusMap[key.status] || '--';
    },
    // 查询按钮
    query() {
      this.searchParam = { ...this.originData };
      if (this.currentPage === 1) {
        this.getTableData();
      } else {
        this.currentPage = 1;
      }
    },
    // 重置按钮
    reset() {
      this.originData.orgnCodeLv3 = '';
      this.clearBy(this, 'audioCode', 'audioCodeName', 'radio');
    },
    // 获取表格数据
    getTableData() {
      this.radio = false;
      this.getPagingData(this.$API.audioParamListQuery);
    },
    // 获取当前行的数据
    showRow(row) {
      this.rowData = row;
      this.radio = this.rowData.orgnCode;
    },
    // 修改按钮
    showAddOrUpdate() {
      if (!this.radio) {
        this.$_yh_alert('请选择一条数据!');
      } else {
        this.audioaddDialog = true;
        this.audioParam = { ...this.audioParam, ...this.rowData };
      }
    },
    // 修改确定
    saveAudioParam() {
      const strid = this.rowData.orgnCode;
      const getdata = this.audioParam;
      if (this.radioRow.id) {
        this.audioParam.id = this.radioRow.id;
      }
      this.$_yh_confirm('此操作将修改一条数据, 是否继续?')
        .then(() => {
          const params = {
            data: {
              orgnCodeLv3: strid,
              ...getdata,
            },
          };
          this.updateParam(params);
        });
    },
    updateParam(params) {
      return this.$_post(this.$API.audioParamUpdate, params)
        .then((res) => {
          if (res.errorCode === this.$CODE.success) {
            this.audioaddDialog = false;
            this.$_yh_alert('修改成功!', '提示', {
              confirmButtonText: '确定',
              callback: () => {
                this.getTableData();
                this.showsave = false;
                this.modifyDic = false;
              },
            });
          } else {
            this.audioaddDialog = false;
            this.$_yh_alert('修改失败!', '提示', {
              confirmButtonText: '确定',
              callback: () => {
                this.modifyDic = false;
              },
            });
          }
        });
    },
    // 修改的状态下拉
    queryAudioParamStatusDict() {
      const parames = {
        data: {
          dictTypeCode: 'audioParamStatus',
        },
      };
      return this.$_post(this.$API.selectDict, parames).then((res) => {
        this.audioParamStatusDict = res.data.list;
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/css/button.scss";

.btn_disable {
  margin: 0;
  outline: none;
  border: 0;
  color: #fff;
  font-size: 12px;
  padding: 3px 14px;
  background-color: #a2a7b3;
  height: 24px;
  border-radius: 12px;
  margin-left: 10px;
}
.btn_foot {
  padding: 10px 16px;
}
.btn_foot_save {
  padding: 10px 16px;
  background-color: #54a6de;
}
</style>
